import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase';
import {
    collection,
    query,
    onSnapshot,
    orderBy,
    limit,
    getDocs,
    doc,
    updateDoc,
    where,
    serverTimestamp
} from 'firebase/firestore';

export const useAdminData = () => {
    const [stats, setStats] = useState({
        totalUsers: 0,
        totalBalance: 0,
        pendingKYC: 0,
        pendingWithdrawals: 0
    });
    const [recentTransactions, setRecentTransactions] = useState<any[]>([]);
    const [pendingApplications, setPendingApplications] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubUsers = onSnapshot(collection(db, 'users'), (snap) => {
            let totalB = 0;
            let pKYC = 0;
            snap.forEach(docSnap => {
                const data = docSnap.data();
                totalB += (data.krw || 0);
                if (data.kyc?.phone === 'Pending' || data.kyc?.idcard === 'Pending') {
                    pKYC++;
                }
            });
            setStats(prev => ({
                ...prev,
                totalUsers: snap.size,
                totalBalance: totalB,
                pendingKYC: pKYC
            }));
        });

        const qTransactions = query(
            collection(db, 'transactions'),
            orderBy('timestamp', 'desc'),
            limit(10)
        );
        const unsubTransactions = onSnapshot(qTransactions, (snap) => {
            const txs: any[] = [];
            snap.forEach(docSnap => txs.push({ id: docSnap.id, ...docSnap.data() }));
            setRecentTransactions(txs);
        });

        const qApps = query(
            collection(db, 'applications'),
            where('status', '==', 'PENDING'),
            orderBy('createdAt', 'desc')
        );
        const unsubApps = onSnapshot(qApps, (snap) => {
            const apps: any[] = [];
            snap.forEach(docSnap => apps.push({ id: docSnap.id, ...docSnap.data() }));
            setPendingApplications(apps);
            setStats(prev => ({ ...prev, pendingWithdrawals: apps.length }));
        });

        setLoading(false);
        return () => {
            unsubUsers();
            unsubTransactions();
            unsubApps();
        };
    }, []);

    const approveApplication = async (appId: string, userId: string, type: string) => {
        try {
            await updateDoc(doc(db, 'applications', appId), { status: 'APPROVED' });

            if (type === 'ID_CARD') {
                const userRef = doc(db, 'users', userId);
                await updateDoc(userRef, {
                    'kyc.idcard': 'Completed',
                    'kyc.level': 2
                });
            } else if (type === 'ACCOUNT') {
                const userRef = doc(db, 'users', userId);
                await updateDoc(userRef, {
                    'kyc.account': 'Completed',
                    'kyc.level': 1
                });
            }
            return { success: true };
        } catch (error) {
            console.error("Approval error:", error);
            return { success: false, error };
        }
    };

    return { stats, recentTransactions, pendingApplications, loading, approveApplication };
};
